module.exports = __webpack_public_path__ + "img/LT112025254.846455dc.png";